import { baseApiUrl } from '../../config/env';

export const getMyTripsApi = async (accessToken, initialCount, count, type) => {
  const queryParam = `from=${initialCount ? initialCount : 1}&to=${
    count ? count : 9999
  }&thirdPartyUserKey=undefined&showExpired=0&destinations=&tripFilterType=${type ? type : ''}`;
  const res = await fetch(`${baseApiUrl}/User/GetMyTrip?` + queryParam, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!res.ok) {
    throw new Error('error doing get My Trips');
  }
  const resultJson = await res.json();
  return resultJson;
};

export const getMyTripsCountApi = async (accessToken) => {
  const res = await fetch(`${baseApiUrl}/User/GetTripsCount?`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!res.ok) {
    throw new Error('error doing get  Trip count');
  }
  const resultJson = await res.json();
  return resultJson;
};

export const getRebookPassengersApi = async (lastName, confirmationNumber) => {
  const res = await fetch(
    `${baseApiUrl}/rebook/passengers?ConfirmationNo=${confirmationNumber}&LastName=${lastName}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );
  if (!res.ok) {
    throw new Error('Error doing get Rebook Passengers');
  }
  return res.json();
};

export const updateTripEventApi = async (accessToken, newEvent) => {
  const body = JSON.stringify(newEvent);
  const res = await fetch(`${baseApiUrl}/Trip/UpdateTripEvent`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body,
  });
  return res;
};
export const createTripEventApi = async (accessToken, newEvent) => {
  const body = JSON.stringify(newEvent);
  const res = await fetch(`${baseApiUrl}/Trip/CreateTripEvent`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${accessToken}`,
    },
    body,
  });
  const createdEvent = await res.json();
  return createdEvent;
};
export const deleteTripEventApi = async (accessToken, eventId) => {
  const queryParam = `tripId=${eventId}`;

  const res = await fetch(`${baseApiUrl}/Trip/DeleteTripEvent?` + queryParam, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  const eventList = await res.json();
  return eventList;
};

export const getTripEventsApi = async (accessToken, tripId) => {
  const queryParam = `tripId=${tripId}`;

  const res = await fetch(`${baseApiUrl}/Trip/GetTripEvents?` + queryParam, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  const eventList = await res.json();
  return eventList;
};

export const updateTripNameApi = async (accessToken, TripId, TripName) => {
  const param = {
    TripName,
    TripId,
  };

  const res = await fetch(`${baseApiUrl}/Cart/SaveTripName`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Authorization: `Bearer ${accessToken}`,
    },
    body: 'param=' + encodeURIComponent(JSON.stringify(param)),
  });

  if (!res.ok) {
    throw new Error('error updating trip name');
  }
  const resultJson = await res.json();
  return resultJson;
};

export const getTezEventApi = async (value) => {
  try {
    const queryParam = `value=${value}`;
    const res = await fetch(`${baseApiUrl}/event/events?` + queryParam, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      timeout: 10000,
    });
    const eventList = await res.json();
    return eventList;
  } catch (e) {
    __DEV__ && console.log('getTezEvent API failed');
  }
};

export const handleCventUrl = async (accessToken, queryParam) => {
  try {
    const newApiUrl = new URL(baseApiUrl);
    const apiUrl = newApiUrl?.origin + newApiUrl?.pathname.split('/api')[0];
    const res = await fetch(`${apiUrl}` + queryParam, {
      method: 'GET',
      headers: {
        'Content-Type': 'text/plain',
        Authorization: `Bearer ${accessToken}`,
      },
      timeout: 10000,
    });
    const resp = await res.json();
    return resp.Content;
  } catch (e) {
    __DEV__ && console.log('handleCventUrl API failed');
  }
};

export const checkEventCode = async (key, meetingCode) => {
  try {
    const res = await fetch(
      `${baseApiUrl}/event/CheckEventCode?` + `key=${key}` + '&' + `meetingCode=${meetingCode}`,
      {
        method: 'POST',
      }
    );
    const meetingData = await res.json();
    return meetingData?.Data;
  } catch (e) {
    __DEV__ && console.log('checkEventCode API failed ->', e);
  }
};

export const getMessageApi = async (companyKey, groupKey, pageLookupKey) => {
  try {
    const res = await fetch(
      `${baseApiUrl}/cart/GetMessage?companyKey=${companyKey}&groupKey=${groupKey}&pageLookupKey=${pageLookupKey}`,
      {
        method: 'GET',
      }
    );
    const messages = await res.json();
    return messages?.Data;
  } catch (e) {
    __DEV__ && console.log('GetMessage API failed ->', e);
  }
};
